import { createRoutine } from "redux-saga-routines";

export const getScreensListRoutine = createRoutine('GET_SCREENS_LIST_ROUTINE');
export const updateScreenRoutine = createRoutine('UPDATE_SCREEN_ROUTINE');
export const sendStreamToScreenRoutine = createRoutine('SEND_STREAM_TO_SCREEN_ROUTINE');
export const updateScreenNameRoutine = createRoutine('UPDATE_SCREEN_NAME_ROUTINE');
export const sendInternalStreamToScreenRoutine = createRoutine('SEND_INTERNAL_STREAM_TO_SCREEN_ROUTINE');